<template>
  <v-alert class="mt-3" color="info" type="info">
    Sorry, this offering is no longer available. Please select another date/time
    from the list above.
  </v-alert>
</template>
